import React, { useEffect, useState } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import { useModal, useAuth } from 'hooks'
import { useEnvironment } from 'hooks'
import { useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import { UserServices } from 'services/Supplier/Users'
import * as yup from 'yup'

import {
  DecorativeLine,
  Button,
  Form,
  Title,
  InputLogin
} from '../../../../components'
import { COLORS, SPACING } from '../../../../utils'
import { Header } from '../../components/Header/Header'
/* import FullScreenLoading from '../../components/ValidatingAccess' */
import { Container, TitleContainer } from './NGTAccessstyles'
import FullScreenLoading from '../ValidatingAccess'

export interface InputValues {
  matricula: string
  isCsn: string | boolean
  password: string
}

const login = yup.object({
  matricula: yup.string().required('Campo obrigatório'),
  password: yup.string().ngtPassword()
})

export const NGTAccess: React.FC = () => {
  const { goBack } = useHistory()
  const { isHomolog } = useEnvironment()
  const { showModal } = useModal()
  const { handleLogin } = useAuth()
  const [notError, setNotError] = useState<boolean>(true)
  const [isHide, setIsHide] = useState<boolean>(false)

  const {
    handleSubmit,
    control,
    formState: { errors }
  } = useForm<InputValues>({
    defaultValues: {
      isCsn: 'true'
    },
    resolver: yupResolver(login)
  })

  const handleValidatingAccess = () => {
    UserServices()
      .getSSOCredentials()
      .then((response) => {
        if (response.status === 200) {
          const { data: matricula } = response
          try {
            handleLogin(
              {
                email: matricula?.toUpperCase(),
                isCsn: true,
                password: '',
                rememberMe: true
              },
              setNotError
            )
          } catch (error) {
            showModal({
              hideButtonCancel: true,
              titleModal: 'Ocorreu um problema.',
              message:
                'Não conseguimos fazer login ao verificar suas credenciais.',
              txtButtonConfirm: 'OK',
              type: 'alert'
            })
            setNotError(false)
          }
        }
      })
      .catch(() => {
        showModal({
          hideButtonCancel: true,
          titleModal: 'Falha ao acessar.',
          message: 'Não conseguimos verificar suas credenciais.',
          txtButtonConfirm: 'OK',
          type: 'alert'
        })
        setNotError(false)
      })
  }

  const handleSubmitLogin = (data: InputValues) => {
    handleLogin({
      email: (data.matricula as string)?.trim().toUpperCase(),
      isCsn: true,
      password: data.password?.trim(),
      rememberMe: true
    })
  }

  useEffect(() => {
    handleValidatingAccess()
  }, [])

  return (
    <>
      {isHomolog && notError ? (
        <>
          <FullScreenLoading title="VERIFICANDO ACESSO" />
        </>
      ) : (
        <>
          <Header />
          <Container>
            <TitleContainer>
              <Title
                fontcolor={COLORS.black}
                marginbottom="15px"
                margintop="15px"
              >
                Faça login na sua conta
              </Title>
            </TitleContainer>
            <DecorativeLine colorLine={COLORS.black} height="4px" />
            <Form
              onSubmit={handleSubmit(handleSubmitLogin)}
              marginLeft={SPACING.spacing50}
              marginRight={SPACING.spacing50}
            >
              <InputLogin
                label="Matrícula"
                formValue="matricula"
                control={control}
                errors={errors}
                marginTop={SPACING.spacing20}
              />
              <InputLogin
                label="Senha"
                formValue="password"
                type={isHide ? 'text' : 'password'}
                inputIcon={isHide ? <VisibilityOff /> : <Visibility />}
                onClickIcon={() => setIsHide(!isHide)}
                control={control}
                errors={errors}
                marginTop={SPACING.spacing20}
              />
              <Button
                text="entrar"
                type="submit"
                variantButton="default"
                marginBottom={SPACING.spacing10}
                marginTop={SPACING.spacing30}
              />
              <Button
                text="Voltar"
                onClick={goBack}
                variantButton="outlined"
                marginBottom={SPACING.spacing20}
                marginTop={SPACING.spacing10}
              />
            </Form>
          </Container>
        </>
      )}
    </>
  )
}
